import { bl_sfa_sales_lead_event_RowClass } from "../../../dbschema/bl_sfa_sales_lead_event.model";
import { BaseContainerModel } from "../../base-container.model";

export class SfaSalesLeadEventContainerModel extends BaseContainerModel {
    bl_sfa_sales_lead_event: bl_sfa_sales_lead_event_RowClass = new bl_sfa_sales_lead_event_RowClass()
}